// extracted by mini-css-extract-plugin
export default {"container":"ShippingView_container__UVUq5","title":"ShippingView_title__FUe0f","sections":"ShippingView_sections__9AEqp"};